export enum Routes {
    Success = 'Success',
    Overview = 'Overview',
    ConstructionTypesStep = 'ConstructionTypesStep',
    WhereStep = 'WhereStep',
    RisksStep = 'RisksStep',
    SumStep = 'SumStep',
    MatrixStep = 'MatrixStep',
    WhenStep = 'WhenStep',
    ContactStep = 'ContactStep',
    SummaryStep = 'SummaryStep',
    ContactEdit = 'ContactEdit',
    MatrixEdit = 'MatrixEdit',
    RiskEdit = 'RiskEdit',
    ConstructionEdit = 'ConstructionEdit',
}
